import React from 'react';

interface VoteBoardTierBadgeProps {
  tier: string;
  label: string;
  color: string;
}

export function VoteBoardTierBadge({ tier, label, color }: VoteBoardTierBadgeProps) {
  const icon = tier === 'gold' ? '\u2605' : tier === 'silver' ? '\u25C6' : '\u25B2';
  return (
    <span
      className="inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-xs font-semibold whitespace-nowrap"
      style={{ borderColor: color, color, backgroundColor: `${color}1A` }}
      title={label}
    >
      {icon} {tier.charAt(0).toUpperCase() + tier.slice(1)}
    </span>
  );
}

export function getVoteBoardUrl(slug?: string | null): string {
  return slug
    ? `https://nft.xrplvoteboard.com/collection/${slug}`
    : 'https://nft.xrplvoteboard.com/';
}
